/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbSharedRefineMenuInputRangeDimensions_filters = $ReadOnlyArray<{|
  +name: ?string;
  +localizedFilterName: ?string;
  +values: ?$ReadOnlyArray<?{|
    +urlLabel: ?string;
    +stats: ?$ReadOnlyArray<?{|
      +key: ?string;
      +values: ?string;
    |}>;
  |}>;
|}>;
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbSharedRefineMenuInputRangeDimensions_filters",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "name",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "localizedFilterName",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 15,
          "type": "Int"
        }
      ],
      "concreteType": "SearchBrowseFilterValue",
      "name": "values",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "urlLabel",
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "stats",
          "name": "stats",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "key",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "values",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "values{\"limit\":15}"
    }
  ],
  "type": "SearchBrowseFilter"
};

module.exports = fragment;
